export default {
  fontFamily: ['"Bai Jamjuree"', "sans-serif"].join(","),
  h1: {
    fontWeight: 500,
    fontSize: 32,
    letterSpacing: "-0.24px",
    fontFamily: "Bai Jamjuree"
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: "-0.24px",
    fontFamily: "Bai Jamjuree"
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: "-0.06px",
    fontFamily: "Bai Jamjuree"
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: "-0.06px",
    fontFamily: "Bai Jamjuree"
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    letterSpacing: "-0.05px",
    fontFamily: "Bai Jamjuree"
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: "-0.05px",
    fontFamily: "Bai Jamjuree"
  },
  overline: {
    fontWeight: 500
  }
};
